import { takeLatest } from "redux-saga/effects";

import { ActionType } from "./types/actionType";
import {
  handleCreateNonInventory,
  handleUpdateNonInventory,
  handleDeleteNonInventory,
  handleRetrieveNonInventory,
  handleRetrieveManyNonInventory,
} from "./workers";

export function* watcher() {
  yield takeLatest(ActionType.CREATE_NON_INVENTORY, handleCreateNonInventory);
  yield takeLatest(ActionType.UPDATE_NON_INVENTORY, handleUpdateNonInventory);
  yield takeLatest(ActionType.DELETE_NON_INVENTORY, handleDeleteNonInventory);
  yield takeLatest(ActionType.RETRIEVE_NON_INVENTORY, handleRetrieveNonInventory);
  yield takeLatest(ActionType.RETRIEVE_MANY_NON_INVENTORY, handleRetrieveManyNonInventory);
}
